/** Super-properties registered on every PostHog capture (web + native). */
export const ANALYTICS_SUPER_PROPERTIES = {
  APP_PLATFORM: 'app_platform',
  // Marca del DESPLIEGUE que sirve el evento (NEXT_PUBLIC_BRAND), no la de alta
  // del padre (`Parent.signupBrand`, propiedad de persona `signup_brand`).
  DEPLOYMENT_BRAND: 'deployment_brand',
} as const

export const APP_PLATFORM = {
  CAPACITOR: 'capacitor',
  WEB: 'web',
} as const

export type AppPlatform = (typeof APP_PLATFORM)[keyof typeof APP_PLATFORM]
